<template>
    <div class="text-center">
      <v-dialog
        v-model="showDialog"
        width="600"
        :persistent="persistent"
      >
        <v-card class="borderDialog">
          <v-card-title v-if="title != ''" class="text-h5  lighten-2">
            {{title}}
          </v-card-title>
  
          <v-card-text class="pb-2">
            <slot></slot>
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              text
              @click="showDialog = false"
              :disabled="disabledImport"
            >
              {{$t("common.close")}}
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="confirm"
              :loading="loadingImport"
            >
                {{$t("common.import")}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>

  <script>
  export default {
    props: {
        dialog: { type: Boolean, default: false },
        title: { type: String, default: '' },
        persistent: { type: Boolean, default: false },
        loadingImport: { type: Boolean, default: false },
        disabledImport: { type: Boolean, default: false }
    },
    computed: {
        showDialog: {
            get() {
                return this.dialog;
            },
            set(val) {
                if(!val) this.close();
            }
        }
    },
    methods: {
        confirm() {
            this.$emit('confirm');
        },
        close() {
            this.$emit('cancel');
        }
    }
  };
</script>
<style scoped>
.v-application .headline {
  font-size: 24px !important;
}
.v-dialog > .v-card > .v-card__text {
    padding: 0 40px 20px;
}
.v-card__actions .v-btn {
    background-color: var(--v-primary-base) !important;
    color: white !important;
}
</style>